export { default as translations } from './translations.json';

export const APPROVAL_STATUSES = ['pending', 'approved', 'rejected'];

export const getApprovalStatus = (listing) =>
  listing?.attributes?.metadata?.approvalStatus || null;

export const isPending = (listing) => getApprovalStatus(listing) === 'pending';
export const isApproved = (listing) => getApprovalStatus(listing) === 'approved';
export const isRejected = (listing) => getApprovalStatus(listing) === 'rejected';
